
(function($) {

    $('.panel-menu-toggle').click(function() {
        $('#site-navigation').toggleClass('active');
        $('.site').toggleClass('panel-open');
        $('body').toggleClass('panel-open');
        $(this).toggleClass("active");
    });

    var total = $('.home-slider .home-slider-slide').length,      
    rand = Math.floor( Math.random() * total ); // random number

    var $homeSlider = $('.home-slider');

    $homeSlider.slick({
        initialSlide: rand,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 3000,
        fade: true,
        speed: 1,
     });

     $homeSlider.on('click', '.slick-slide', function() {
        $homeSlider.slick('slickNext');
        console.log('click');
    });


    var $status = $('#pagingInfo');
    var $slider = $('.obra-slider');
    

    $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.html('<span class="current-slide">' + i + '</span>' + ' / ' + slick.slideCount);

        // var lightBox = $('.slick-lightbox');
        // console.log('My slick  lightbox instance:', lightBox);
    });    
    

    $slider.slick({
        prevArrow: $('.slider-prev'),
        nextArrow: $('.slider-next'),
        infinite: false,
    });

    $slider.slickLightbox({
        src: 'src',
        itemSelector: '.obra-slider-item img',
        background: 'rgba(255, 255, 255, 0.9)',
        slick: {
            prevArrow: '<button id="lightbox-prev" class="obra-slider_arrow obra-slider_arrow_previous slick-prev slick-arrow" aria-label="Previous" type="button">←</button>',
            nextArrow: '<button id="lightbox-next" class="obra-slider_arrow obra-slider_arrow_next slick-next slick-arrow" aria-label="Next" type="button">→</button>',
            infinite: false,
        },
        
    });




    // Listen for the `shown.slickLightbox` event
    $slider.on('shown.slickLightbox', function() {
        // Access the slickLightbox instance
        const slickLightboxInstance = $slider[0].slickLightbox;
        const slickInstance = slickLightboxInstance.slick;

        if (slickInstance) {

            function createLightboxHeader() {
                // Define the HTML structure
                var headerHtml = `
                    <div id="lightbox-header" class="obra-slider-header">
                        <span id="lightbox-counter"></span>
                    </div>
                `;
            
                // Find .slick-lightbox-inner and prepend the HTML
                $('.slick-lightbox-inner').prepend(headerHtml);
            }
            createLightboxHeader();
            

            lightboxPrev = $('#lightbox-prev');
            lightboxNext = $('#lightbox-next');
            lightboxHeader = $('#lightbox-header');

            function moveArrowsToHeader() {
                $(lightboxHeader).append(lightboxNext);
                $(lightboxHeader).prepend(lightboxPrev);
            }
            moveArrowsToHeader();

            
            // Function to extract values from $status and update the counter
            function updateLightboxCounter() {
                // Extract values from $status
                var currentSlideText = $status.find('.current-slide').text().trim();
                var totalSlidesText = $status.text().split('/').pop().trim(); // Use pop() to get the last part
                
                // Parse the values
                var currentSlide = parseInt(currentSlideText, 10);
                var totalSlides = parseInt(totalSlidesText, 10);
                
                // Handle possible NaN values by setting defaults
                currentSlide = isNaN(currentSlide) ? 0 : currentSlide;
                totalSlides = isNaN(totalSlides) ? 0 : totalSlides;
                
                // Update the counter
                $('#lightbox-counter').html('<span class="current-slide">' + currentSlide + '</span>' + ' / ' + totalSlides);
            }

            updateLightboxCounter();


            slickInstance.on('afterChange', function (event, slick, currentSlide) {
                console.log('on afterchange');
                // Handle currentSlide being undefined on 'init' (set to 0 in this case)
                var i = (currentSlide ? currentSlide : 0) + 1;
                $('#lightbox-counter').html('<span class="current-slide">' + i + '</span>' + ' / ' + slick.slideCount);
            });
        }
    });

    // Optional: Listen for the `hide.slickLightbox` or `hidden.slickLightbox` events
    $slider.on('hidden.slickLightbox', function() {
        console.log('Lightbox closed.');
    });
          
})( jQuery );  

document.addEventListener("DOMContentLoaded", function() {
    // Get the current URL path
    var path = window.location.pathname;

    // --- ✅ Hardcoded cases ---
    if (path.endsWith("/exposicoes/")) {
        document.getElementById("exposicoes-link")?.classList.add("active");
        return;
    } else if (path.endsWith("/exposicoes/individuais/")) {
        document.getElementById("individuais-link")?.classList.add("active");
        return;
    } else if (path.endsWith("/exposicoes/coletivas/")) {
        document.getElementById("coletivas-link")?.classList.add("active");
        return;
    }
    // --- ✅ End hardcoded cases ---

    // Remove language prefix if present and get the "real" path segment
    var segments = path.split('/').filter(Boolean);
    var pathSegment = segments.length > 1 && segments[0].length === 2 ? segments[1] : segments[0];

    // Find all navigation links
    var navLinks = document.querySelectorAll('.navigation__links a');

    // Loop through each navigation link
    navLinks.forEach(function(link) {
        // Get the link's href attribute
        var href = link.getAttribute('href');
        // Extract the relevant segment from the href
        var hrefSegments = href.split('/').filter(Boolean);
        var hrefSegment = hrefSegments.length > 1 && hrefSegments[0].length === 2 ? hrefSegments[1] : hrefSegments[0];

        // Check if the extracted segments match
        if (pathSegment && hrefSegment && pathSegment === hrefSegment) {
            // Add the 'active' class to the parent li element
            link.parentNode.classList.add('active');
            // Add the 'active' class to the parent of the parent (grandparent) if it exists
            var grandparentLi = link.parentNode.parentNode;
            if (grandparentLi && grandparentLi.classList.contains('navigation__links-group')) {
                grandparentLi.classList.add('active');
            }
        }
    });
});


document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll('.trp-ls-shortcode-language');

    elements.forEach(element => {
        const anchors = element.querySelectorAll('a');
        anchors.forEach((anchor, index) => {
            if (index < anchors.length - 1) { // Check if it's not the last <a>
                const span = document.createElement('span');
                span.textContent = '/';
                anchor.insertAdjacentElement('afterend', span);
            }
        });
    });
});



document.addEventListener("DOMContentLoaded", function() {
    //  Textos page only START
    if (document.body.classList.contains('post-type-archive-texto')) {
        // Function to get URL parameters using URLSearchParams
        function getUrlParameter(name) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
        }

        // Get the 'texto' parameter from the URL
        var slug = getUrlParameter('ler');

        if (slug) {
            // Find the corresponding collapsible element
            var collapsible = document.querySelector('li[data-slug="' + slug + '"]');

            if (collapsible) {
                // Find the checkbox input within the collapsible
                var checkbox = collapsible.querySelector('.toggle');

                if (checkbox) {
                    // Check the checkbox to open the collapsible
                    checkbox.checked = true;

                    // Scroll to the collapsible element
                    collapsible.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        }

        
         // Select all the accordion headers
        const accordionHeaders = document.querySelectorAll('.lbl-toggle');

        // Add click event listener to each accordion header
        accordionHeaders.forEach(header => {
            header.addEventListener('click', function() {
                // Get the parent <li> element
                const parentLi = this.closest('li.wrap-collabsible');

                // Get the data-slug attribute
                const slug = parentLi.getAttribute('data-slug');

                // Update the URL parameter
                updateUrlParameter('ler', slug);

                // Close any other open accordions
                closeOtherAccordions(parentLi);
            });
        });

        // Function to update URL parameter
        function updateUrlParameter(key, value) {
            const url = new URL(window.location.href);
            url.searchParams.set(key, value);
            window.history.pushState({}, '', url);
        }

        // Function to close other open accordions
        function closeOtherAccordions(openLi) {
            // Select all the accordion <li> elements
            const allAccordions = document.querySelectorAll('ul.posts-list li.wrap-collabsible');

            allAccordions.forEach(li => {
                if (li !== openLi) {
                    const checkbox = li.querySelector('.toggle');
                    if (checkbox && checkbox.checked) {
                        checkbox.checked = false;
                    }
                }
            });
        }

        // Textos page only END
    }
});
